import React, { FC, useMemo } from 'react'
import { VStack, Image } from '@chakra-ui/react'
import { InputDefault } from './input-default'
import { cardImageMap } from '../../state/interfaces'

export interface InputPhoneNumberProps {
  placeholder?: string
  onChange?: (values: string[]) => void
  name: string
  grandImage?: string
}

export const InputPhoneNumber: FC<InputPhoneNumberProps> = ({ placeholder, onChange, name, grandImage }) => {
  const image = useMemo(() => (grandImage ? cardImageMap[grandImage] : ''), [grandImage])

  return (
    <VStack spacing={3} gridRowGap={4}>
      <InputDefault placeholder={placeholder} onChange={onChange} inputType="phone" name={name} />
      <Image src={image} alt="image" width={['200px', '250px']} height={['200px', '250px']} />
    </VStack>
  )
}
